import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryShowcase() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <p className="font-heading text-accent-500 text-sm tracking-[0.2em] uppercase mb-3 whitespace-nowrap">
            Explore Categories
          </p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            找到你的<span className="text-primary-600">风格部落</span>
          </h2>
          <p className="text-foreground-600 text-sm max-w-lg mx-auto leading-relaxed">
            五大风格部落，每一个都是一扇通往不同自我的门。推开它，发现你未曾见过的自己。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {categories.map((cat, idx) => (
            <Link
              key={cat.id}
              to={`/categories?tab=${cat.slug}`}
              className="group relative flex flex-col items-center p-6 rounded-lg bg-background-50 hover:bg-background-50 transition-all duration-300"
            >
              <div className={`w-14 h-14 md:w-16 md:h-16 rounded-full flex items-center justify-center mb-4 transition-all duration-300 ${
                idx === 0 ? 'bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50' :
                idx === 1 ? 'bg-secondary-100 text-secondary-600 group-hover:bg-secondary-500 group-hover:text-background-50' :
                idx === 2 ? 'bg-accent-100 text-accent-700 group-hover:bg-accent-500 group-hover:text-background-50' :
                idx === 3 ? 'bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50' :
                'bg-secondary-100 text-secondary-600 group-hover:bg-secondary-500 group-hover:text-background-50'
              }`}>
                <i className={`${
                  idx === 0 ? 'ri-fire-line' :
                  idx === 1 ? 'ri-star-line' :
                  idx === 2 ? 'ri-windy-line' :
                  idx === 3 ? 'ri-moon-line' :
                  'ri-shape-line'
                } text-2xl`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2 text-center whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-foreground-600 text-xs text-center leading-relaxed line-clamp-3 mb-3">
                {cat.description}
              </p>
              <span className="text-accent-500 text-xs whitespace-nowrap">
                {cat.articleCount} 篇文章
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}